<template>
    <td-dialog
        @cancel="protIndialogClose"
        :title="title"
        :before-close="protIndialogClose"
        :visible.sync="dialogImportVisible"
        width="550px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
                <td-upload
                    actionUrl="/devCtlProt/uploadFile"
                    :autoUpload="true"
                    :on-success="handResponse"
                    :on-error="handResponse"
                    message="message.UPLOAD_PROMPT"
                    :multiple="true"
                    :limit="10"
                    :showFileList="true"
                    accept=".json"
                    :limitSize="200"
                ></td-upload>
            </el-form-item>
        </el-form>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogImportVisible'],
    created() {},
    // 定义变量
    data() {
        return {};
    },
    // 定义并实现方法体
    methods: {
        handResponse(response, file) {
            this.$log.error('/dialogImport/handResponse1', response);
            if (null === response) {
                this.$log.error('/dialogImport/handResponse', response);
                this.$message({ showClose: true, message: file.name + this.$t('common.UPLOADFAILED'), type: 'error' });
                return;
            }
            if (response.statusCode !== this.$t('common.REQUEST_SUCCESS')) {
                this.$log.error('/dialogImport/handResponse1', response);
                this.$message({ showClose: true, message: file.name + this.$t('common.UPLOADFAILED'), type: 'error' });
                return;
            }
            this.$message({ showClose: true, message: file.name + this.$t('common.UPLOADSUCESSE'), type: 'success' });
        },
        // 关闭窗口之前需要调用的方法
        protIndialogClose() {
            this.$emit('protIndialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
